import { IconChevronRight } from '@tabler/icons-react';
import clsx from 'clsx';
import React from 'react';
import { Text } from 'src/design/atoms/Text';
import type { RenderTreeNodePayload } from 'src/design/molecules/Tree';
import classes from './TreeRow.module.css';

export interface ITreeRowProps {
  payload: RenderTreeNodePayload;
  icon?: React.ReactNode;
  label: React.ReactNode;
  trailing?: React.ReactNode;
  onSelect?: (value: string) => void;
}

/** @registry House row for the design-layer Tree: chevron, 14px leading icon, truncating label and right-aligned trailing content; the row selects (click, Enter, Space) while the chevron only expands. */
export const TreeRow: React.FC<ITreeRowProps> = ({
  payload,
  icon,
  label,
  trailing,
  onSelect,
}) => {
  const { node, expanded, hasChildren, tree, elementProps } = payload;

  return (
    <div
      {...elementProps}
      data-tree-row
      className={clsx(elementProps.className, classes.row)}
      onClick={(event) => {
        elementProps.onClick(event);
        onSelect?.(node.value);
      }}
    >
      {hasChildren ? (
        <IconChevronRight
          size={14}
          className={clsx(classes.chevron, expanded && classes.chevronExpanded)}
          onClick={(event) => {
            event.stopPropagation();
            tree.toggleExpanded(node.value);
          }}
        />
      ) : (
        <span className={classes.chevron} />
      )}
      {icon && <span className={classes.icon}>{icon}</span>}
      <span className={classes.label}>
        {typeof label === 'string' ? (
          <Text size="sm" c="bright" truncate>
            {label}
          </Text>
        ) : (
          label
        )}
      </span>
      {trailing && <span className={classes.trailing}>{trailing}</span>}
    </div>
  );
};
